<script setup lang="ts">
interface TileItemProps {
  minHeight: number;
  title: string;
  description: string;
  icon?: string;
  color?: string;
}

defineProps<TileItemProps>();
</script>

<template>
  <v-sheet :color="color" rounded class="sheet elevation" :style="{ minHeight: `${minHeight}px` }">
    <v-icon size="64">{{ icon }}</v-icon>
    <p class="mt-2 text-h5 text-primary-lighten-5" data-testid="tileItemTitle">
      {{ title }}
    </p>
    <p class="mt-4 text-body-3 text-primary-lighten-5" data-testid="tileItemDescription">
      {{ description }}
    </p>
  </v-sheet>
</template>
<style lang="scss" scoped>
.icon {
  text-align: center;
}

.sheet {
  padding: 24px 24px 32px 24px;
  text-align: center;
}
// todo: add as global elevation handling?
.elevation {
  box-shadow:
    0px 6px 6px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 10px 14px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 4px 18px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12)) !important;
  transition:
    box-shadow 0.2s,
    opacity 0.2s;
}

.elevation:hover {
  box-shadow:
    0px 8px 10px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 16px 24px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 6px 30px 5px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12)) !important;
  opacity: 0.9;
}

.elevation:active {
  box-shadow:
    0px 1px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 16px 24px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 6px 30px 5px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12)) !important;
}
</style>
